import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-20 px-4" data-id="element-241">
      <div className="max-w-4xl mx-auto" data-id="element-242">
        <div className="bg-bg-alt border-2 border-cta-green/40 shadow-[0_0_50px_rgba(34,197,94,0.15)] rounded-3xl p-6 sm:p-12 relative overflow-hidden" data-id="element-243">
          {/* Subtle background glow */}
          <div className="absolute inset-0 pointer-events-none opacity-60" style={{
          background: 'radial-gradient(ellipse at top, rgba(34,197,94,0.08) 0%, transparent 70%)'
        }} data-id="element-244" />

          <div className="relative z-10 grid grid-cols-1 sm:grid-cols-[auto_1fr] gap-6 sm:gap-10 items-center" data-id="element-245">
            {/* 7-day stamp */}
            <div className="mx-auto sm:mx-0 flex flex-col items-center justify-center w-32 h-32 sm:w-40 sm:h-40 rounded-full border-4 border-cta-green/60 bg-cta-green/10 shadow-[0_0_30px_rgba(34,197,94,0.3)] relative" data-id="element-246">
              <ShieldCheckIcon className="absolute top-3 w-5 h-5 sm:w-6 sm:h-6 text-cta-green" strokeWidth={2.5} data-id="element-247" />
              <span className="text-cta-green font-black text-5xl sm:text-6xl leading-none tracking-tighter mt-3" data-id="element-248">
                7
              </span>
              <span className="text-cta-green font-black text-[10px] sm:text-xs uppercase tracking-[0.2em] mt-1" data-id="element-249">
                giorni
              </span>
            </div>

            {/* Content */}
            <div className="text-center sm:text-left" data-id="element-250">
              <span className="inline-flex items-center gap-2 text-cta-green font-black text-[10px] sm:text-xs uppercase tracking-[0.2em] bg-cta-green/10 border border-cta-green/30 px-3 py-1 rounded-full mb-3" data-id="element-251">
                ✓ Rischio zero per te
              </span>
              <h2 className="text-2xl sm:text-4xl font-black text-text-main mb-3 tracking-tight leading-[1.1]" data-id="element-252">
                Provalo 7 giorni.
                <br data-id="element-253" />
                <span className="text-cta-green" data-id="element-254">
                  Se non funziona, ti rimborsiamo tutto.
                </span>
              </h2>
              <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-255">
                Apri il Kit, stampa una scheda, usala in classe. Se non senti
                subito la differenza,{' '}
                <span className="text-text-main font-bold" data-id="element-256">
                  ti restituiamo ogni euro
                </span>{' '}
                — senza chiederti il motivo.
              </p>
            </div>
          </div>

          {/* Proof bullets */}
          <div className="relative z-10 grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-3 mt-6 sm:mt-8 pt-6 border-t border-cta-green/20" data-id="element-257">
            {[{
            title: 'Rimborso al 100%',
            sub: 'Ogni centesimo torna sul tuo conto'
          }, {
            title: '1 sola email',
            sub: 'Nessun modulo, nessuna telefonata'
          }, {
            title: 'Tieni tutto',
            sub: 'I file restano comunque tuoi'
          }].map((b, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-dark/40 border border-white/10 rounded-xl px-3 py-3 sm:py-3.5" data-id="element-258">
                <span className="flex items-center justify-center w-5 h-5 rounded-full bg-cta-green/20 border border-cta-green/40 flex-shrink-0 mt-0.5" data-id="element-259">
                  <CheckIcon className="w-3 h-3 text-cta-green" strokeWidth={4} data-id="element-260" />
                </span>
                <div className="min-w-0" data-id="element-261">
                  <p className="text-text-main font-black text-[13px] sm:text-sm leading-tight" data-id="element-262">
                    {b.title}
                  </p>
                  <p className="text-text-sec text-[11px] sm:text-xs leading-snug mt-0.5" data-id="element-263">
                    {b.sub}
                  </p>
                </div>
              </div>)}
          </div>

          {/* Signature line */}
          <p className="relative z-10 text-center text-text-sec text-[11px] sm:text-xs font-medium mt-5 italic" data-id="element-264">
            — Promesso dal team Matematica Pronta
          </p>
        </div>
      </div>
    </section>;
}